import { CLIENT_ID_SETTINGS } from "@/common/constants";
import apiCall from "./apiCall";

const getSettingInspectionFeeById = async (id: string) => {
    const URL = `/Settings/GetInspectionFeeById/${id}`;
    return apiCall('get', URL);
};

const getSettingsById = async (id: string) => {
    const URL = `/Settings/GetSettingsById/${id}`;
    return apiCall('get', URL);
};

const putSetting = async (data: any) => {
    const URL = '/Settings/Update';
    return apiCall('post', URL, data);
};

const getSettingsVessel = async () => {
    const URL = `/Settings/GetSettingsVessel/${CLIENT_ID_SETTINGS}`;
    return apiCall('get', URL);
};

export {
    getSettingInspectionFeeById,
    getSettingsById,
    putSetting,
    getSettingsVessel,
};
